import { type FormEvent, useState } from "react";

const STORAGE_KEY = "cadec_preview_ok";

/**
 * クライアント確認用の簡易ロック（フロントのみ・パスワードはビルドに埋め込まれる）。
 * `.env` の VITE_PREVIEW_PASSWORD を空にすると無効。
 */
export function PreviewGate({ children }: { children: React.ReactNode }) {
  const expected = import.meta.env.VITE_PREVIEW_PASSWORD?.trim() ?? "";

  const [unlocked, setUnlocked] = useState(() => {
    if (!expected) return true;
    try {
      return sessionStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });
  const [input, setInput] = useState("");
  const [error, setError] = useState(false);

  if (!expected || unlocked) {
    return <>{children}</>;
  }

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    setError(false);
    if (input.trim() === expected) {
      try {
        sessionStorage.setItem(STORAGE_KEY, "1");
      } catch {
        /* ignore */
      }
      setUnlocked(true);
      return;
    }
    setError(true);
    setInput("");
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex min-h-screen flex-col items-center justify-center px-6"
      style={{ background: "#111111" }}
    >
      <p
        className="mb-2 text-center text-xs tracking-[0.2em] text-white"
        style={{ fontFamily: '"Inter", sans-serif' }}
      >
        PREVIEW
      </p>
      <h1
        className="mb-10 text-center font-bold text-white"
        style={{
          fontFamily: '"Noto Sans JP", sans-serif',
          fontSize: "clamp(17px, 3.5vw, 20px)",
          letterSpacing: "0.04em",
        }}
      >
        確認用ページです
      </h1>
      <form
        onSubmit={onSubmit}
        className="flex w-full max-w-[280px] flex-col gap-4"
      >
        <label className="sr-only" htmlFor="preview-password">
          パスワード
        </label>
        <input
          id="preview-password"
          type="password"
          name="password"
          autoComplete="current-password"
          value={input}
          onChange={(e) => {
            setInput(e.target.value);
            setError(false);
          }}
          placeholder="パスワード"
          className="w-full border border-white/40 bg-white/10 px-4 py-3 text-sm text-white outline-none placeholder:text-white/80 focus:border-white/70"
          style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
        />
        <button
          type="submit"
          className="w-full border border-white/25 bg-white/10 py-3 text-xs tracking-widest text-white transition hover:bg-white/15"
          style={{ fontFamily: '"Inter", sans-serif' }}
        >
          表示する
        </button>
        {error && (
          <p
            className="text-center text-xs text-red-400/90"
            style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
          >
            パスワードが違います
          </p>
        )}
      </form>
      <p
        className="mt-12 max-w-md text-center text-[11px] leading-relaxed text-white/90"
        style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
      >
        簡易ロックのため、ブラウザの開発者ツール等で回避できます。
        <br />
        公開時はビルド前に VITE_PREVIEW_PASSWORD を削除してください。
      </p>
    </div>
  );
}
